var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H82V82H8C3.58172 82 0 78.4183 0 74V8Z",
    fill: "#10848B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H82V82H8C3.58172 82 0 78.4183 0 74V8Z",
    fill: "white",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0769 25.6154H29.9231C27.544 25.6154 25.6154 27.544 25.6154 29.9231V43.1908L28.111 40.7628C30.5783 38.3623 34.4893 38.3017 37.0298 40.6246L43.5747 46.6087C44.98 47.8936 47.1313 47.9013 48.5456 46.6264C49.8484 45.4521 51.7968 45.3545 53.2103 46.3927L56.3846 48.7241V29.9231C56.3846 27.544 54.456 25.6154 52.0769 25.6154ZM29.9231 25C27.2041 25 25 27.2041 25 29.9231V52.0769C25 54.7959 27.2041 57 29.9231 57H52.0769C54.7959 57 57 54.7959 57 52.0769V29.9231C57 27.2041 54.7959 25 52.0769 25H29.9231ZM47.1492 38.5391C48.9619 38.5391 50.4313 37.0697 50.4313 35.2571C50.4313 33.4444 48.9619 31.975 47.1492 31.975C45.3366 31.975 43.8672 33.4444 43.8672 35.2571C43.8672 37.0697 45.3366 38.5391 47.1492 38.5391Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighten);
export default __webpack_public_path__ + "static/media/lighten.0b16fb48.svg";
export { ForwardRef as ReactComponent };